export const LOGIN_SUCCESS='login/success';
export const LOGIN_FAILED='login/failure';
export const LOGIN_REQUEST='login/loading';
export const LOGOUT='logout';
export const LOAD_PROFILE='profile/load';